import { api } from "@/http/api-client"
import type { TGetOrganizationResponse } from "./types"

export function getOrganization(slug: string) {
  return api.get<TGetOrganizationResponse>(`/organizations/${slug}`)
}
